var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.file-icon{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "file-icon",
    d: "M18.7507 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H14.2507L19.5007 8.25V20.25C19.5007 20.3485 19.4813 20.446 19.4436 20.537C19.406 20.628 19.3507 20.7107 19.2811 20.7803C19.2114 20.85 19.1287 20.9052 19.0377 20.9429C18.9468 20.9806 18.8492 21 18.7507 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "file-icon",
    d: "M14.25 3V8.25H19.5007"
  }), /*#__PURE__*/React.createElement("path", {
    className: "file-icon",
    d: "M9.375 13.875L12 11.25L14.625 13.875"
  }), /*#__PURE__*/React.createElement("path", {
    className: "file-icon",
    d: "M12 17.25V11.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.6277ac8b926780681f32227939d65efa.svg";
export { ForwardRef as ReactComponent };